import { InjectionToken, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { reducers, State } from '../shared/reducers/bfa-reducers';
import { SharedModule } from '../shared/shared.module';
import { ReportGenerationService } from './services';

export const BFA_REDUCERS = new InjectionToken<ActionReducerMap<State>>('bfa-reducers');

@NgModule({
	imports: [
		SharedModule,
		CwpNgFrameworkModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		StoreModule.forFeature('bfa', BFA_REDUCERS),
		MatSlideToggleModule,
		NgxSkeletonLoaderModule,
		DzButtonModule
	],
	providers: [
		{
			provide: BFA_REDUCERS,
			useValue: reducers
		},
		ReportGenerationService
	]
})
export class BfaComponentsModule { }
